import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { eur } from "@/lib/api";
import { Printer } from "lucide-react";

function fmtTime(iso) {
  try { return new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }); }
  catch (e) { return ""; }
}

export default function KitchenTicket({ order, onClose }) {
  if (!order) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="kitchen-ticket" className="max-w-xs w-[calc(100%-2rem)] rounded-2xl bg-white text-black p-0 overflow-hidden">
        <DialogTitle className="sr-only">Ticket cuisine Table {order.table_number}</DialogTitle>
        <DialogDescription className="sr-only">Détail de la commande {order.order_number} pour la cuisine</DialogDescription>
        <div className="kitchen-ticket p-5 font-mono">
          <div className="text-center border-b-2 border-dashed border-black pb-3 mb-3">
            <p className="text-lg font-bold uppercase">Le Comptoir Parisien</p>
            <p className="text-sm">TICKET CUISINE</p>
          </div>
          <div className="flex justify-between text-2xl font-bold mb-1">
            <span>TABLE {order.table_number}</span>
            <span className="text-lg">{order.order_code || order.order_number}</span>
          </div>
          <p className="text-xs mb-3">{fmtTime(order.created_at)}{order.guest_name ? ` · ${order.guest_name}` : ""}</p>
          <div className="border-t-2 border-dashed border-black pt-3 space-y-3">
            {order.items.map((it, k) => (
              <div key={k}>
                <p className="text-base font-bold">{it.quantity}× {it.name}</p>
                <div className="text-sm pl-4 leading-snug">
                  {(it.formula || []).map((f, i) => <p key={`f${i}`}>» {f.course} : <span className="font-bold">{f.choice}</span></p>)}
                  {(it.options || []).map((o, i) => <p key={`o${i}`}>» {o.group} : <span className="font-bold">{o.value}</span></p>)}
                  {it.cooking && <p>» Cuisson : <span className="font-bold">{it.cooking}</span></p>}
                  {it.side && <p>» Accomp. : {it.side}</p>}
                  {(it.supplements || []).map((s, i) => <p key={i}>» + {s.name}</p>)}
                  {it.instructions && <p className="font-bold uppercase">!! {it.instructions}</p>}
                </div>
              </div>
            ))}
          </div>
          <div className="border-t-2 border-dashed border-black mt-3 pt-2 flex justify-between text-sm font-bold">
            <span>TOTAL</span><span>{eur(order.total)}</span>
          </div>
        </div>
        <div className="no-print p-4 border-t border-stone-200 flex gap-2">
          <Button variant="outline" onClick={onClose} className="flex-1 rounded-full">Fermer</Button>
          <Button data-testid="ticket-print-btn" onClick={() => window.print()} className="flex-1 rounded-full bg-[#123026] hover:bg-[#0A1C16] text-white">
            <Printer className="w-4 h-4 mr-1.5" /> Imprimer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
